module.exports = __webpack_public_path__ + "img/53f1149.png";